const fields = Object.freeze({
  emailAddress: 'emailAddress',
  countryId: 'countryId',

  reqId: 'reqId',
  parsedReqId: 'parsedReqId',
  entityName: 'entityName',
  actionType: 'actionType',
  actionStatus: 'actionStatus',
  fxAccountName: 'fxAccountName',
  creationDate: 'creationDate',
  amexContactEmail: 'amexContactEmail',
  digitalAssetGroup: 'digitalAssetGroup',
  protocols: 'protocols',
  environment: 'environment',
  myActions: 'myActions',
  manageDigitalAssets: 'manageDigitalAssets',
  manageContacts: 'manageContacts',
  contactInfo: 'contactInfo',
  updateContactInfo: 'updateContactInfo',
  userDetails: 'userDetails',
  fxAccount: 'fxAccount',
  updatePassword: 'updatePassword',
  home: 'home',
  lastPasswordChangedTime: 'lastPasswordChangedTime',
  activateFxAccount: 'activateFxAccount',
});

export default fields;
